"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApDatePicker = void 0;
var React = require("react");
var DayPicker = require("react-day-picker/DayPicker");
var ApDatePicker_styles_1 = require("./ApDatePicker.styles");
var NavBar_1 = require("./NavBar");
var utils_1 = require("./utils");
var YearMonthForm_1 = require("./YearMonthForm");
var ApDatePicker = /** @class */ (function (_super) {
    __extends(ApDatePicker, _super);
    function ApDatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDayChange = function (date) {
            _this.props.onChange([date]);
        };
        _this.handleDayEnter = function (date) {
            var range = _this.props.range;
            _this.setState({
                hoverRange: range ? utils_1.getWeekRange(date, range) : {
                    from: date,
                    to: date,
                },
            });
        };
        _this.handleDayLeave = function () {
            _this.setState({
                hoverRange: undefined,
            });
        };
        _this.handleYearMonthChange = function (month) {
            _this.setState({ month: month });
        };
        var isSelectedDays = Boolean(props.selectedDays.length);
        _this.state = {
            hoverRange: {
                from: new Date(),
                to: new Date(),
            },
            month: isSelectedDays ? props.selectedDays[0] : new Date(),
        };
        return _this;
    }
    ApDatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, selectedDays = _a.selectedDays, srcRange = _a.srcRange;
        var _b = this.state, hoverRange = _b.hoverRange, month = _b.month;
        var daysRangeSelected = selectedDays.length > 1;
        var modifiers = {
            hoverRange: hoverRange,
            hoverRangeStart: hoverRange && hoverRange.from,
            hoverRangeEnd: hoverRange && hoverRange.to,
        };
        if (daysRangeSelected) {
            modifiers = __assign(__assign({}, modifiers), { selectedRange: {
                    from: selectedDays[0],
                    to: selectedDays[selectedDays.length - 1],
                }, selectedRangeStart: selectedDays[0], selectedRangeEnd: selectedDays[selectedDays.length - 1] });
        }
        return (React.createElement(ApDatePicker_styles_1.Container, null,
            React.createElement(DayPicker.default, __assign({ month: month, firstDayOfWeek: 1, showOutsideDays: true, pagedNavigation: true, modifiers: modifiers, onDayClick: this.handleDayChange, onDayMouseEnter: this.handleDayEnter, onDayMouseLeave: this.handleDayLeave, onMonthChange: function (m) { return _this.setState({ month: m }); }, captionElement: function (_a) {
                    var date = _a.date, localeUtils = _a.localeUtils;
                    return (React.createElement(YearMonthForm_1.YearMonthForm, { date: date, localeUtils: localeUtils, srcRange: srcRange, onChange: _this.handleYearMonthChange }));
                }, navbarElement: function (props) { return (React.createElement(NavBar_1.Navbar, __assign({}, props, { srcRange: srcRange, date: month }))); } }, this.props))));
    };
    return ApDatePicker;
}(React.Component));
exports.ApDatePicker = ApDatePicker;
;
//# sourceMappingURL=ApDatePicker.js.map